import { registerTab } from "lib/@components/tabs"
import { RuleSetsTab } from "./rule-sets-tab"

registerTab({
    tab: "optimiser",
    id: "rule-sets",
    title: "Rule Sets",
    content: <RuleSetsTab $lazy priority={40} />,
})
